
import { Grid } from '@mui/material';
import { withStyles } from '@mui/styles';
import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import CustomizedCircularProgress from '../../components/CustomCircularProgress';
import CustomDrawer from '../../components/CustomDrawer';

//card test: 378282246310005

class ProcessFormView extends Component {
    componentDidUpdate() {
        let paymentForm = document.forms['paymentForm'];
        if(paymentForm){
          paymentForm.submit()
        }
    }
    
    render() {
        const { t, html_content } = this.props;

        return (
            <div>
                <CustomDrawer
                    open={this.props.open}
                    onClose={() => this.props.onClose()}
                    title={t('Process')}
                    enableBack
                >
                    <div style={{ width: '100%' }} dangerouslySetInnerHTML={{ __html: html_content }} />
                    <Grid xs={12} item container justify='center'><CustomizedCircularProgress /></Grid>
                </CustomDrawer>
            </div>
        );
    }
}

const styles = theme => ({

});

export default withStyles(styles)(withTranslation()(ProcessFormView));